import whenDomReady from "when-dom-ready";

import initVideoModal from "../common/VideoModal";

whenDomReady(async () => {
  if (document.querySelector("[data-component=carousel]")) {
    const { default: initCategoryCarousels } = await import(
      "../common/initCategoryCarousels"
    );
    initCategoryCarousels();
  }

  const shopTheLook = document.querySelector("[data-component=shopTheLook]");

  if (shopTheLook) {
    const { default: ShopLook } = await import("./ShopLook");
    new ShopLook();
  }

  const pagingControls = document.querySelector("#paging");

  if (pagingControls) {
    const { default: Paging } = await import("./Paging");
    new Paging();
  }

  const enhancedCarousels = document.querySelectorAll(
    "[data-component=categoryCarousel]",
  );

  if (enhancedCarousels.length) {
    const { default: LimitSlider } = await import("../common/LimitSlider");

    enhancedCarousels.forEach((enhancedCarousel) => {
      new LimitSlider({
        selector: enhancedCarousel,
        perPage: {
          0: 2,
          500: 3,
          768: 4,
          946: 5,
          1440: 6,
        },
        onInit() {
          this.selector.classList.add("grid-slider--init");
        },
      });
    });
  }

  const carouselWraps = document.querySelectorAll("[data-component=carousel]");

  if (carouselWraps.length) {
    const { default: FixedWidthCarousel } = await import(
      "../common/FixedWidthCarousel"
    );

    carouselWraps.forEach((carouselWrap) => {
      const carousel = carouselWrap.querySelector(".ag-carousel");

      new FixedWidthCarousel({
        selector: carousel,
        slideWidth: 199,
      });
    });
  }

  initVideoModal();
});
